<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter1" id="calibre_pb_0">
<span id="Page_18" title="18"></span>
<h2 class="c4" id="pgepubid00005">ASTROLOGY, &amp;c.</h2>
</div>
<p class="c13">“This is the excellent foppery of the world, that when we are
sick in fortune (often the surfeit of our own behaviour)
we make guilt of our disasters, the sun, the moon, and the
stars; as if we were villains by necessity; fools by heavenly
compulsion; knaves, thieves, and treachers (traitors), by
spherical predominance; drunkards, liars, and adulterers, by
an inforced obedience of planetary influence; and all that we
are evil in by a Divine thrusting on; an admirable evasion of
whoremaster to lay his goatish disposition to the charge of a
star! My father compounded with my mother under the Dragon’s
tail; and my nativity was under <i class="calibre12"><span xml:lang="la">Ursa Major</span></i>; so that it
follows, I am rough and lecherous.—Tut, I should have been
that I am, had the maidenliest star in the firmament twinkled
at my bastardizing.”—<span class="sc">Shakspeare.</span></p>
<p class="c10">It is a singular fact, that men the most eminent
for their learning were those who indulged most in
the favourite superstition of judicial Astrology;
and as the ingenious Tenhove observes, whenever
an idea germinates in a learned head, it shoots with
additional luxuriance. At the present time, however,
a belief in judicial Astrology can only exist
in the people, who may be said to have no belief
at all; for mere traditional sentiments can hardly
be said to amount to a belief.</p>
<p class="c11">It is said that Dr. Fludd<a id="r6"></a><span class="c12" href="#/Text/Section0044#f6" title="Link target outside of Sample"><sup class="calibre13">[6]</sup></span> was in possession of
<span id="Page_19" title="19"></span>the MSS. of Simon Forman, the Astrologer. We
have seen that the studies of Mathematics, Astronomy,
and Medicine, were early united in several
persons connected with the faculty of medicine.
Real Astronomy gave birth to judicial Astrology;
which offering an ample field to enthusiasm and
imposture, was eagerly pursued by many who had
no scientific purpose in view. It was connected
with various juggling tricks and deceptions, affected
an obscure jargon of language, and insinuated
itself into every thing in which the hopes and
fears of mankind were concerned. The professors
of this pretended science were at first generally
persons of mean education, in whom low cunning
supplied the place of knowledge. Most of them
engaged in the empirical practice of physic, and
some, through the credulity of the times, even
arrived at a degree of eminence in it; yet since
the whole foundation of their art was folly and
deceit, they nevertheless gained many proselytes
and dupes, both among the well-informed and the
ignorant.</p>
<p class="c11">When Charles the First was confined, Lilly, the
famous Astrologer, was consulted for the hour that
should favour his escape.</p>
<p class="c11">A story, which strongly proves how much
Charles II. was bigoted to judicial astrology, and
whose mind was certainly not unenlightened, is
recorded in Burnet’s History of his own times.
The most respectable characters of the age, Sir
William Dugdale, Elias Ashmole, Dr. Grew, and
others, were members of an astrological club<a id="r7"></a><span class="c12" href="#/Text/Section0044#f7" title="Link target outside of Sample"><sup class="calibre13">[7]</sup></span>.
<span id="Page_20" title="20"></span>Congreve’s character of Foresight, in Love for
Love, was then no uncommon person, though the
humour now is scarcely intelligible. Dryden cast
the nativities of his sons; and, what is remarkable,
his prediction relating to his son Charles, was accomplished.
This incident is of so late a date,
one might hope it would have been cleared up;
but, if it be a fact, it must be allowed that it forms
a rational exultation for its irrational adepts.</p>
<p class="c11">In 1670, the passion for horoscopes and expounding
the stars, prevailed in France among the
first rank. The new-born child was usually presented
naked to the astrologer, who read the first
lineaments in its forehead, and the transverse lines
in its hands, and thence wrote down its future
destiny. Catherine de Medicis brought Henry IV.
then a child, to old Nostradamus, whom antiquaries
esteem more for his Chronicle of Provence than for
his vaticinating powers. The sight of the reverend
seer, with a beard which “streamed like a meteor
in the air,” terrified the future hero, who dreaded
a whipping from so grave a personage. Will it
be credited, that one of these magicians, having
assured Charles IX. that he would live as many
days as he should turn about on his heels in an
hour, standing on one leg, that his Majesty every
morning performed that solemn exercise for an
hour; the principal officers of the court, the judges,
<span id="Page_21" title="21"></span>the chancellors, and generals, likewise, in compliment,
standing on one leg, and turning round!</p>
<p class="c11">It has been reported of several famous for their
astrological skill, that they have suffered a voluntary
death merely to verify their own predictions:
this has been said of Cardan, and Burton the author
of the Anatomy of Melancholy.</p>
<p class="c11">It is curious to observe the shifts to which astrologers
are put when their predictions are not verified.
Great winds were predicted, by a famous adept,
about the year 1586. No unusual storms, however,
happened. Bodin, to save the reputation of
the art, applied it as a figure to some <em class="calibre12">revolutions</em>
in the state, and of which there were instances
enough at that moment. Among their lucky and
unlucky days, they pretend to give those of various
illustrious persons and of families. One is very
striking:—Thursday was the unlucky day of our
Henry VIII. He, his son Edward VI. Queen
Mary, and Queen Elizabeth, all died on a <em class="calibre12">Thursday</em>!
This fact had, no doubt, great weight in this controversy
of the astrologers with their adversaries.</p>
<p class="c11">The life of Lilly, the astrologer, written by himself,
is a curious work. He is the <em class="calibre12">Sidrophel</em> of
Butler. It contains so much artless narrative,
and at the same time so much palpable imposture,
that it is difficult to know when he is speaking
what he really believes to be the truth. In a sketch
of the state of astrology in his day, those adepts,
whose characters he has drawn, were the lowest
miscreants of the town. They all speak of each
other as rogues and impostors. Such were Booker,
George Wharton, Gadbury, who gained a livelihood
<span id="Page_22" title="22"></span>by practising on the credulity of even men of
learning so late as in 1650, to the 18th century.
In Ashmole’s life an account of these artful impostors
may be found. Most of them had taken the
air in the pillory, and others had conjured themselves
up to the gallows. This seems a true statement
of facts. But Lilly informs us, that in his
various conferences with <em class="calibre12">angels</em>, their voice resembled
that of the Irish! The work is certainly
curious for the anecdotes of the times it contains.
The amours of Lilly with his mistress are characteristic.
By his own accounts, he was a very
artful man; and managed matters admirably which
required deception and invention.</p>
<p class="c11">In the time of the civil wars, astrology was in
high repute. The royalists and the rebels had
their <em class="calibre12">astrologers</em> as well as their <em class="calibre12">soldiers</em>! and the
predictions of the former had a great influence
over the latter. On this subject, it may gratify
curiosity to notice three or four works which bear
an excessive price; a circumstance which cannot
entirely be occasioned by their rarity; and we are
induced to suppose, that we still have adepts in
this science, whose faith must be strong, or whose
scepticism weak.</p>
<p class="c11">The Chaldean sages were nearly put to the route
by a quarto park of artillery, fired on them by
Mr. John Chamber, in 1691. Apollo did not use
Marsyas more inhumanly than his scourging pen
this mystical race, and his personalities made them
feel more sore. However, a Norwich knight, the
very Quixote of astrology, arrayed in the enchanted
armour of his occult authors, encountered this
<span id="Page_23" title="23"></span>pagan in a most stately carousal. He came forth
with “A defence of Judiciall Astrologye, in answer
to a treatise lately published by Mr. John
Chamber. By Christopher Knight. Printed at
Cambridge, 1603.” This is a handsome quarto of
about 500 pages. Sir Christopher is a learned
and lively writer, and a knight worthy to defend a
better cause. But his Dulcinea had wrought most
wonderfully on his imagination. This defence of
this fanciful science, if science it may be called,
demonstrates nothing, while it defends every thing.
It confutes, according to the Knight’s own ideas:
it alleges a few scattered facts in favour of astrological
predictions, which may be picked up in that
immensity of fabling which disgraces history. He
strenuously denies, or ridicules, what the greatest
writers have said against this fanciful art, while
he lays great stress on some passages from obscure
authors, or what is worse, from authors of no
authority. The most pleasant part is at the close,
where he defends the art from the objections of
Mr. Chamber, by recrimination. Chamber had
enriched himself by medical practice, and when
he charges the astrologers by merely aiming to
gain a few beggarly pence, Sir Christopher catches
fire, and shews by his quotations, that if we are to
despise an art by its professors attempting to subsist
on it, or for the objections which may be raised
against its vital principles, we ought by this argument
most heartily to despise the medical science
and medical men! He gives here all he can collect
against physic and physicians, and from the
confessions of Hippocrates and Galen, Avicenna
<span id="Page_24" title="24"></span>and Agrippa, medicine appears to be a vainer
science than even astrology! Sir Christopher is a
shrewd and ingenious adversary; but when he says
he only means to give Mr. Chamber oil for his
vinegar, he has totally mistaken its quality.</p>
<p class="c11">The defence was answered by Thomas Vicars,
in his “Madnesse of Astrologers.”</p>
<p class="c11">But the great work is by Lilly; and entirely
devoted to the adepts. He defends nothing; for
this oracle delivers his <i class="calibre12"><span xml:lang="la">dictum</span></i>, and details every
event as matters not questionable. He sits on the
tripod; and every page is embellished by a horoscope,
which he explains with the utmost facility.
This voluminous monument of the folly of the age,
is a quarto, valued at some guineas! It is entitled,
“Christian Astrology, modestly treated of
in three Books, by William Lilly, student in Astrology,
2nd edition, 1659.” There is also a
portrait of this arch rogue, and astrologer! an
admirable illustration for Lavater!</p>
<p class="c11">Lilly’s opinions, and his pretended science, were
such favourites of the age, that the learned Gataker
wrote professedly against this popular delusion.
Lilly, at the head of his star-expounding friends,
not only formally replied to, but persecuted Gataker
annually in his predictions, and even struck at
his ghost, when beyond the grave. Gataker died
in July 1654, and Lilly having written in his
Almanack of that year, for the month of August,
this barbarous Latin verse:—</p>
<div class="lg-container-b">
<div class="linegroup">
<div class="group">
<div class="line1"><span xml:lang="la">Hoc in tumbo, jacet presbyter et nebulo!</span></div>
</div>
<div class="group">
<div class="line">Here in this tomb lies a presbyter and a knave!</div>
</div>
</div>
</div>
<p class="c14">He had the impudence to assert, that he had predicted
<span id="Page_25" title="25"></span>Gataker’s death! But the truth is, it was an
epitaph to the “lodgings to let:” it stood empty,
ready for the first passenger to inhabit. Had any
other of that party of any eminence died in that
month, it would have been as appositely applied
to him. But Lilly was an exquisite rogue, and
never at a fault. Having prophesied, in his Almanack
for 1650, that the parliament stood upon a
tottering foundation, when taken up by a messenger
during the night, he contrived to cancel the
page, printed off another, and shewed his copies
before the committee, assuring them that the
others were none of his own, but forged by his
enemies.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?01a73f47